<script lang="ts">
    import {getInjector} from 'src/core';
    import type {Document, Fond} from 'src/typings';
    import type {FondFieldRelationLink} from 'src/features/record/kp-related-records-table/types';
    import type {RawDynamicFieldSearchParam, RawRowCreationParams} from 'src/features/record-grid/lib/types';
    import {onMount} from 'svelte';
    import {KpRelatedRecordsTablePresenter} from './kp-related-records-table.presenter';
    import {createRelationsContext} from 'src/features/record/kp-related-records-table/relations.context';
    import {exists} from 'shared/utils/custom-utils';
    import KpRecordGrid from '../../record-grid/KpRecordGrid.svelte';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import RelationsRowOptionsCell from 'src/features/record/kp-related-records-table/RelationsRowOptionsCell.svelte';
    import {isNotEmpty} from 'shared/utils/array-utils';
    import {
        resolveDynamicFieldSearchParams,
        resolveRowCreationParams,
        TemplatePlaceholderResolver
    } from 'src/features/record-grid/lib/types-utils';

    export let record: Document;
    export let fondId: number;
    export let dynamicFieldSearchParams: RawDynamicFieldSearchParam[] | null;
    export let rowCreationParams: RawRowCreationParams | null;
    export let relations: FondFieldRelationLink[] | null = null;

    const presenter = getInjector().getByClass(KpRelatedRecordsTablePresenter);

    let loading = true;
    let fonds: Fond[] = [];

    $: referenceRecordId = record.id;
    $: templatePlaceholderResolver = new TemplatePlaceholderResolver(referenceRecordId, fondId);

    onMount(async () => {
        fonds = await presenter.getIncludableFonds(fondId);
        loading = false;
    });

    createRelationsContext(relations ?? []);
</script>

{#if loading}
    <KpLoadingBlock/>
{/if}

{#if !loading && fonds.length > 0}
    <KpRecordGrid {referenceRecordId}
                  {...exists(relations) && isNotEmpty(relations) ? {rowOptionsCellComponent: RelationsRowOptionsCell} : {}}
                  fondOrFondId={fonds.at(0)}
                  dynamicFieldSearchParams={resolveDynamicFieldSearchParams(dynamicFieldSearchParams, templatePlaceholderResolver)}
                  rowCreationParams={resolveRowCreationParams(rowCreationParams, templatePlaceholderResolver)}
                  infiniteScroll/>
{/if}